import utils from "../../utils";
import cache from "../../utils/cache";
import { getUrlParams } from "../../utils/urlParams";
import apis from "../../request/apis";
import state from "../state";

// 兼容参数写在 hash 前面(/?storeType=4/#/xxx?tenantId=1)和写在 hash 里面(/#/xxx?tenantId=1)两种情况
const allParmas = getUrlParams()
console.log('allParmas', allParmas);
if(allParmas.tenantId) {
  cache.setLocal("datacenteruuid", allParmas.tenantId);
}

if (allParmas['header']) {
    const extractTenantId = (str) => {
        const regex = /Tenant-Id["']?\s*:\s*["']?([^"']+)/i;
        const match = str.match(regex);
        return match ? match[1].replace(/["']/g, '') : null;
    };

    let tenantId = null;

    try {
        const decodedHeader = decodeURIComponent(allParmas['header']);
        const urlObject = JSON.parse(decodedHeader);
        tenantId = urlObject['Tenant-Id'];
    } catch (error) {
        try {
            const altHeader = allParmas['header'].replace(/%22/g, '"');
            const urlObject = JSON.parse(altHeader);
            tenantId = urlObject['Tenant-Id'];
        } catch (e) {
            tenantId = extractTenantId(allParmas['header']) || extractTenantId(decodeURIComponent(allParmas['header']));
        }
    }

    if (tenantId) {
        cache.setLocal("datacenteruuid", tenantId);
    }
}

export default {
    namespaced: true,
    state: {
        phonecode: cache.getLocal("phonecode") || [], //手机区号
        dataconter: cache.getLocal("dataconter") || [], //数据中心
        datacenteruuid: allParmas.tenantId||cache.getLocal("datacenteruuid") || '', //数据中心默认id
        locationList: [], //国家列表
        customerServiceInfo: {}, // 客服信息
        position: {}, //位置信息 经纬度
        store: null, //门店信息 经纬度
        storeSearchId: '', // 门店搜索id
        reg_platform_type: cache.getLocal("regplatformtype") || null, // 渠道来源
        isBack: false, // 是否是后退操作
        La: cache.getLocal("La") || {}, // 经纬度
        deviceType: cache.getLocal("deviceType") || 1, //设备类型   1 phone 2 pad  3 h5
    },

    mutations: {
        changeDeviceType(state, payload) {
            console.log(state,payload);

            state.deviceType = payload;
            cache.setLocal("deviceType", payload);
        },
        changePhonecode(state, payload) {
            state.phonecode = payload;
            cache.setLocal("phonecode", state.phonecode);
        },

        changeDataconter(state, payload) {
            state.dataconter = payload;
            cache.setLocal("dataconter", state.dataconter);
            // 判断路由是否有tenantId参数，没有则默认第一个
            console.log('dataconter',state.dataconter);
            let index = state.dataconter.findIndex(i => i.tenantId == allParmas['tenantId'] || state.datacenteruuid);
            state.dataconter[0] && (index<0) && this.commit("common/changeDataconterId", state.dataconter[0].tenantId)
        },

        changeDataconterId(state, payload) {
            state.datacenteruuid = payload;
            cache.setLocal("datacenteruuid", payload);
        },

        changeLocationList(state, payload) {
            let new_payload = payload.map(country => {
                if(country.addressStateList && country.addressStateList.length) {
                    let addressStateList = country.addressStateList.map(state => {
                        if(state.addressCityEntities && state.addressCityEntities.length) {
                            let addressCityEntities = state.addressCityEntities.map(city => {
                                return {
                                    ...city,
                                    type: "city",
                                    name: city.name,
                                    value: city.id,
                                }
                            })
                            state.children = addressCityEntities;
                            state.addressCityEntities = null;
                        }
                        return {
                            ...state,
                            type: "province",
                            name: state.name,
                            value: state.id,
                        }
                    })
                    country.children = addressStateList;
                    country.addressStateList = null;
                }
                return {
                    ...country,
                    type: "country",
                    name: country.name,
                    value: country.id,
                }
            })
            state.locationList = new_payload;
            // cache.setSession("locations", state.locationList);
        },

        changeCustomerServiceInfo(state, payload) {
            state.customerServiceInfo = payload;
            cache.setSession("customerServiceInfo", state.customerServiceInfo);
        },

        changePosition(state, payload) {
            state.position = {
                longitude: payload.longitude,
                latitude: payload.latitude,
                accuracy: payload.accuracy
            };
            cache.setLocal("position", state.position);
        },

        saveStore(state, payload) {
            state.store = payload;
            cache.setSession("store", state.store);
        },

        setStoreId(state, payload) {
            state.storeSearchId = payload;
        },

        saveRegPlatformType(state, payload) {
            state.reg_platform_type = payload;
            cache.setLocal("regplatformtype", state.reg_platform_type);
        },

        changeIsBack(state, payload) {
            state.isBack = payload;
        },

        savePosition(state, payload) {
            state.La = payload;
            cache.setLocal("La", state.La);
        }
    },

    actions: {
        getPhoneCode(store) {
            const phonecode = store.state.phonecode;
            store.dispatch("requestPhonecode");
        },

        requestPhonecode(store, params) {
            return new Promise((resolve, reject) => {
                apis.common.getTelephoneAreaCodeList({}).then(res => {
                    store.commit("changePhonecode", res.data);
                    resolve();
                }).catch(reject);
            })
        },

        getDateCenterList(store) {
            const dataconter = store.state.dataconter;
            store.dispatch("requestDataconter");
        },

        requestDataconter(store, params) {
            return new Promise((resolve, reject) => {
                let params = {}
                if(store.state.La.latitude) {
                    params = store.state.La;
                }
                apis.common.getDateCenterList(params).then(res => {
                    store.commit("changeDataconter", res.data.records);
                    resolve(res.data.records);
                }).catch(reject);
            })
        },

        getLocationList(store) {
            // return new Promise((resolve, reject) => {
            //     apis.common.getLocationList({page: 1, limit: 999}).then(res => {
            //         store.commit("changeLocationList", res.data.records);
            //         resolve();
            //     }).catch(reject);
            // })
        },

        getCustomerServiceInfo(store, id) {
            return new Promise((resolve, reject) => {
                apis.common.getCustomerServiceInfo({
                    user_id: store.rootState.user.user_id,
                }).then(res => {
                    store.commit("changeCustomerServiceInfo", res.data || {});
                    resolve();
                }).catch(reject);
            })
        },

        getPosition(store) {
            utils.getPositionLa().then(coords => {
                store.commit("changePosition", coords)
            })
            .catch(err=>{
              console.log('getPositionLa error: ', err);
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js